import React from 'react'
import { Row, Separator } from '@fs/zion-ui'
import { NoticeLoading } from '@fs/zion-icon'

/**
 * @typedef {object} Props
 * @property {'xxl' | 'xl' | 'lg' | 'md' | 'sm' | 'xs' | 'xxs' | 'nano' | 'hide'} separatorSize
 * @property {'xs' | 'sm' | 'md' | 'lg'} size
 */

/**
 *
 * @param {Props} param0
 * @returns
 */

export default function CenteredLoadingSpinner({ size = 'lg', separatorSize = 'xxl' }) {
  return (
    <div data-testid="spinner">
      <Separator size={separatorSize} />
      <Row alignX="center">
        <NoticeLoading size={size} />
      </Row>
      <Separator size={separatorSize} />
    </div>
  )
}
